let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1bSzQ")).then(() => parcelRequire('jZ69H'));